import Icon from '../components/Icon.vue'

Icon.register({
  motorcycle: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M512.9 192C498.1 191.9 483.8 194.3 470.5 198.9L437.6 144H520C533.3 144 544 133.3 544 120V88C544 74.7 533.3 64 520 64H474.7A24-24 0 0 1 456.9 71.9L419.4 113.6 396.6 75.7A24-24 0 0 1 376 64H296C287.2 64 280 71.2 280 80V96C280 104.8 287.2 112 296 112H362.4L381.6 144H227.9C210.2 120.9 183 104 128 104H72.5C59.1 104 47.7 115 48 128.5 48.3 141.5 58.9 152 72 152H128C152.5 152 166.7 162.9 175.8 176.8L164.5 197.3C151.5 193.4 137.6 191.6 123.2 192.1 55.9 194.5 1.6 249.6 0 317-1.6 389.1 56.3 448 128 448 187.6 448 237.7 407.2 252 352H336.2C349.9 352 360.8 340.6 360.2 326.9 358 279.8 377.7 233.3 416.4 201.9L428.8 222.7C401.2 246.4 383.7 281.6 384 320.9 384.5 390.4 441.2 447.3 510.8 448 582.4 448.7 640.6 390.5 640 318.9 639.4 249.3 582.5 192.5 512.9 192zM128 400C83.9 400 48 364.1 48 320S83.9 240 128 240C132.2 240 136.4 240.3 140.5 241L99 316.4C90.2 332.4 101.8 352 120 352H201.3C188.9 380.2 160.7 400 128 400zM516.4 399.9C470.3 402.3 432 365.6 432 320 432 298.6 440.4 279.2 454.1 264.9L503.5 347.2C508.1 354.8 517.9 357.2 525.5 352.7L539.2 344.5C546.8 339.9 549.2 330.1 544.7 322.5L496.1 241.6A80-80 0 0 0 512 240C557.6 240 594.3 278.3 591.9 324.4 589.7 364.9 556.9 397.7 516.4 399.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/motorcycle.js
// module id = Rbvd
// module chunks = 144